import { memo } from "react";

import SkeletonComparePlayer from "@/components/organisms/SkeletonComparePlayer";
import { Box } from "@/components/atoms/Box";

/**
 * Props for the LoadingSkeletonView component
 */
interface LoadingSkeletonViewProps {
  /**
   * Whether the screen is mobile-sized
   */
  readonly isSmall: boolean;
}

/**
 * LoadingSkeletonView displays a loading skeleton while compare players data is being fetched.
 * Shows a full-screen skeleton with header to prevent flash of unstyled content.
 * @param props - Component props
 * @param props.isSmall - Whether the screen is mobile-sized
 */
const LoadingSkeletonView = ({ isSmall }: LoadingSkeletonViewProps) => (
  <Box className={!isSmall ? "flex-1" : "flex-1 px-4 pt-6"}>
    <SkeletonComparePlayer />
  </Box>
);

LoadingSkeletonView.displayName = "LoadingSkeletonView";

export default memo(LoadingSkeletonView);
